<yc-input
  [name]="controlName"
  [leftIcon]="{
    icon: currencyRequestedSymbol,
    isStaticText: true
  }"
  [rightIcons]="rightIcons"
  [disabled]="disabled"
  [label]="label"
  [help]="helpText"
  [currencyData]="formattingData[currencyRequested]"
  [isNumber]="true"
  (onChange)="_onAmountChange()">
</yc-input>